import { toast } from "react-toastify";
import { useGeolocation } from "@uidotdev/usehooks";
import { CircularProgress, IconButton } from "@mui/material";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";
import { useIntl } from "react-intl";

const errorMessages = {
  1: "geolocation_permission_denied",
  2: "geolocation_unavailable",
  3: "geolocation_timeout",
};

const FindMyLocation = ({ onClick }) => {
  const { formatMessage } = useIntl();
  const { error, latitude, longitude, loading } = useGeolocation({
    enableHighAccuracy: true,
    maximumAge: 5000,
    timeout: 10000,
  });

  const findMe = () => {
    if (error) {
      toast.error(formatMessage({ id: errorMessages[error.code] || "geolocation_unavailable" }));
    } else if (!loading) {
      return onClick([longitude, latitude]);
    }
  };

  if (loading) {
    return <CircularProgress size={30} color="primary" />;
  }

  return (
    <IconButton
      size="small"
      color="primary"
      onClick={findMe}
      aria-label={formatMessage({ id: "find_my_location" })}
      sx={{ bgcolor: "action.hover" }}
    >
      <MyLocationRoundedIcon fontSize="small" />
    </IconButton>
  );
};

export default FindMyLocation;
